import Layout from '@layout/Index'

export const executiveBudget = [
  {
    path: '/executive-budget',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "executive-budget-table" */ './pages/ExecutiveBudgetTable.vue'),
        meta: {
          title: '执行预算分配列表',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "executive-budget-detail" */ './pages/ExecutiveBudgetDetail.vue'),
        meta: {
          title: '加值金额分配-编辑',
        },
      },
      {
        path: 'approve/table',
        component: () => import(/* webpackChunkName: "executive-approve-table" */ './pages/ExecutiveApproveTable.vue'),
        meta: {
          title: '执行审批',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/executive-budget/executive-budget.route.js